import React, { Component } from 'react';
import { connect } from 'react-redux';

import { TargetLayout } from 'components';

class CtTargetLayout extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { isDetailView } = this.props;
    return <TargetLayout isDetailView={isDetailView} />;
  }
}

const mapStateToProps = state => ({
  isDetailView: state.currentStatus.get('isDetailView')
});

export default connect(mapStateToProps)(CtTargetLayout);



// WEBPACK FOOTER //
// ./src/script/containers/target/CtTargetLayout.js